import "./about.css";
import profileData from "../../data/ProfileData";
import StrongSpan from "../../elements/StrongSpan"
import Button from "../../elements/Button";
const About = () => {

  return (
    <>
      <div className="
          flex flex-col items-center justify-center min-h-screen
          md:flex-row md:px-6
          lg:px-16 lg:pt-12 
        ">

        {/* Image  */}
        <div
          data-aos-delay="0"
          data-aos="fade-right"
          className="  
          mb-16 w-[200px] 
          sm:w-[270px] sm:mb-8 
          md:w-[300px]
          lg:w-[350px]  
        ">
          <img className="
          rounded-b-full rounded-tr-full shadow-2xl bg-slate-800 shadow-slate-700
          "
            src={require("./imgs/kashifkamran-profile.png")} alt="" />
        </div>

        {/* Pitch */}
        <div
          data-aos="fade-left"
          className="
          md:w-4/6
          lg:w-3/5 
        ">
          <h1 className="
          font-semibold text-center text-white mb-3 
          text-[18px] px-2 
          md:text-[22px] md:ml-6
          lg:text-[28px] 
        ">
            Hey, this is <StrongSpan>{profileData.personalInfo.firstName + " " + profileData.personalInfo.lastName}</StrongSpan> a programming enthusiast who believes <StrongSpan>Ctrl+C</StrongSpan> and <StrongSpan>Ctrl+V</StrongSpan> are the ultimate superpowers.
          </h1>
          <p className="text-[#ABB2BF] my-8">
          </p>
          <div className="flex justify-center">
            <Button>
              Contact me!!
            </Button>
          </div>
        </div>
      </div>

    </>
  );
};

export default About;
